import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col } from 'react-bootstrap';
import { loginActions } from '../../../store/user-login.reducer';
import ButtonIcon from '../../button';
import backgroundImg from "../../../../img/full-page-bg.jpg"
import clientLogo from "../../../../img/ATEM-LOGO-White@2x.png"
class InvalidAccess extends Component {
    logout = async (e) => {
        const {logout} = this.props;
        e.preventDefault();
        logout();
      }
    render() {
        return (
            <div>
                <div className="login-container">
                        <div className="login-left-container">
                            <img src={backgroundImg} alt="background" className="blue-img"/>
                            <h1 className="login-header">Welcome to</h1>
                            <h1 className="login-sub-header">ATEM</h1>
                            <span className="login-sub-text">
                                Accenture Technology Expense Management
                            </span>
                        </div>
                        <div className="login-right-container">
                            <div className="item-body invalid-access-body">
                                <div className="access-denied-container">
                                    <Col className="access-denied-logo"></Col>
                                    <Col className="access-denied-text">
                                        <h1>ACCESS DENIED</h1>
                                        <p>You are not authorized to access this page. Please contact the <u>ATEM Support Team</u>.</p>
                                    </Col>
                                </div>
                            </div>
                            <ButtonIcon onClick={(e) => this.logout(e)} iconLeft="sign-out-alt" iconSize="16px" customClassName="userprofile-logout" labelName="Login page"/> 
                        </div>
                        
                    </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators(loginActions, dispatch)
    }
  }
  
  function mapStateToProps(state) {
        return {
            ...state,
            ...state.history
        };
  }

export default connect(mapStateToProps, mapDispatchToProps)(InvalidAccess);
